import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import ProtectedRoute from "./routes/ProtectedRoute";
import Login from "./pages/Login/Login";
import Dashboard from "./pages/Dashboard/Dashboard";
import Agents from "./pages/Agents/Agents";
import Targets from "./pages/Targets/Targets";
import OrdersList from "./pages/OrdersList/OrdersList";
import OrderAssignment from "./pages/OrderAssignment/OrderAssignment";
import Controllers from "./pages/Controllers/Controllers";
import Profile from "./pages/Profile/Profile";
import RouteOptimization from "./pages/RouteOptimization/RouteOptimization";
// import Logs from "./pages/Logs/Logs";
import Vehicles from "./pages/Vehicles/Vehicles";
import Cities from "./pages/Cities/Cities";
import OrderDetails from "./pages/OrderDetails/OrderDetails";
import AddOrder from "./pages/AddOrder/AddOrder";
import ScreenSizeBlocker from "./components/layout/ScreenBlocker";
import CompletedOrders from "./pages/CompletedOrders/CompletedOrders";
import DocumentAllowance from "./pages/DocumentAllowance/DocumentAllowance";
import Stock from "./pages/Stock/Stock";
import RouteResults from "./pages/RouteResults/RouteResults";
import RouteDetails from "./pages/RouteDetails/RouteDetails";
import "./App.css";

function App() {
  return (
    <ScreenSizeBlocker>
      <Router>
        <Routes>
          {/* Public Route */}
          <Route path="/login" element={<Login />} />
          {/* Protected Routes */}
          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/agents" element={<Agents />} />
            <Route path="/targets" element={<Targets />} />
            <Route path="/controllers" element={<Controllers />} />
            <Route path="/orders" element={<OrdersList />} />
            <Route path="/order-assignment" element={<OrderAssignment />} />
            <Route path="/route-optimization" element={<RouteOptimization />} />
            <Route path="/cities" element={<Cities />} />
            <Route path="/vehicles" element={<Vehicles />} />
            <Route path="/profile" element={<Profile />} />
            {/* <Route path="/logs" element={<Logs />} /> */}
            <Route path="/orders/:id" element={<OrderDetails />} />
            <Route path="/add-order" element={<AddOrder />} />
            <Route path="/completed-order" element={<CompletedOrders />} />
            <Route path="/document-access" element={<DocumentAllowance />} />
            <Route path="/stock" element={<Stock />} />
            <Route path="/route-results" element={<RouteResults />} />
            <Route path="/route-details/:id" element={<RouteDetails />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
          </Route>
        </Routes>
      </Router>
    </ScreenSizeBlocker>
  );
}

export default App;
